export const DEFAULT_IMAGE_SIZE_NAME = [
  "10 x 15 cm sijaj",
  "10 x 15 cm lesklý",
  "10 x 15 cm gloss",
  "10 x 15 cm glänzend",
  "10 x 15 cm błyszczący",
];
